
export const categoriesNav = [
    {url: '/categories', label: 'Categories', key: 'categories.index', permissions: []},
    // {url: '/categories/one', label: 'Subcategories 1 lvl', key: 'subcategories.one.index', permissions: []},
    // {url: '/categories/two', label: 'Subcategories 2 lvl', key: 'subcategories.two.index', permissions: []},
]